import { useEffect, useRef, useState } from "react";
import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import PurchaseHeader from "./purchaseComponents/PurchaseHeader";
import { FaChevronDown, FaChevronUp, FaRegCopy } from "react-icons/fa";
import { CircularProgress, Collapse, Snackbar } from "@mui/material";
import { SPECIAL_LABEL } from "../../constants/constant";
import { useMutation } from "@tanstack/react-query";
import {
  fetchPaymentDetail,
  fetchPaymentDetailPbf,
  OtpCheckout,
  paymentCheck,
  paymentCheckPbf,
  verifyCheckoutOtpNew,
} from "../../../services/purchaseApi";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";
import moment from "moment";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const COUNTDOWN_SECOND = 60;

const CheckoutConfirm = ({ dataPreview }) => {
  const navigate = useNavigate();
  const isTaxFree = localStorage.getItem("is_tax_free");
  const { invoiceNum } = useParams();
  const intervalRef = useRef(null);

  const [collapseOrder, setCollapseOrder] = useState(true);
  const [collapseShipping, setCollapseShipping] = useState(true);
  const [collapsePayment, setCollapsePayment] = useState(true);
  const [otpString, setOtpString] = useState(["", "", "", ""]);
  const [pinString, setPinString] = useState(["", "", "", "", "", ""]);
  const [countdownSeconds, setCountdownSeconds] = useState(COUNTDOWN_SECOND);
  const [isPressed, setIsPressed] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [errorVerify, setErrorVerify] = useState(false);
  const [collapsePaymentArr, setCollapsePaymentArr] = useState(null);
  const [time, setTime] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  const getShippingFee = () => {
    // return dataPreview.shipping
    //   ? dataPreview.shipping.reduce((acc, num) => acc + num?.price_shipping, 0)
    //   : 0;
    return 0;
  };

  // const handleInputOtp = (e, index, type) => {
  //   const stringType = type === "otp" ? otpString : pinString;
  //   const newString = [
  //     ...stringType.slice(0, index),
  //     !isNaN(Number(e.target.value))
  //       ? e.target.value.length === 1
  //         ? Number(e.target.value)
  //         : e.target.value.length === 0
  //           ? ""
  //           : ""
  //       : "",
  //     ...stringType.slice(index + 1),
  //   ];

  //   if (type === "otp") setOtpString(newString);
  //   if (type === "pin") setPinString(newString);

  //   setErrorVerify(false);
  //   setErrorMessage("");

  //   if (e.target.value.length === 1 && e.target.nextElementSibling) {
  //     e.target.nextElementSibling.focus();
  //   }
  //   if (e.target.value.length === 0 && e.target.previousElementSibling) {
  //     e.target.previousElementSibling.focus();
  //   }

  //   if (!newString.includes("") && dataPreview) {
  //     handleVerifyOtp(newString);
  //   }
  // };

  // const handleVerifyOtp = (newString) => {
  //   const body = {
  //     code:
  //       dataPreview.payment?.id === 19 ||
  //       dataPreview.payment?.id === 24 ||
  //       dataPreview.payment?.id === 21 ||
  //       dataPreview.payment?.id === 23 ||
  //       !newString
  //         ? "111111" // if payment method CC, Olin Paylater, or Olin Amanah send 111111
  //         : newString.join(""),
  //     payment_id: dataPreview.payment?.id,
  //     shipping: dataPreview.dataCheckout.cart.pbf.map((item, i) => ({
  //       pbf_id: item.id,
  //       shipping_id: dataPreview.shipping[i].id,
  //       note: dataPreview.noteArr[i],
  //     })),
  //     shop: dataPreview.dataCheckout.result.shop,
  //     total_discount: dataPreview.dataCheckout.result.discount,
  //     voucher_id: dataPreview.voucher ? [dataPreview.voucher.voucher_id] : [], // TODO: Change to Array
  //     total:
  //       dataPreview.grandTotal +
  //       (dataPreview.usePoint ? dataPreview.dataCheckout.loyalty_point : 0),
  //     fee: dataPreview.payment?.bank_fee,
  //     ppn:
  //       isTaxFree === "true"
  //         ? 0
  //         : Math.round(dataPreview.dataCheckout.result.shop * 0.11),
  //     data: [],
  //     is_inventory: false,
  //     shipping_fee: getShippingFee(),
  //     doku_credit_card_tenor:
  //       dataPreview.payment?.id !== null
  //         ? dataPreview.creditDetail?.installment_type
  //         : 0,
  //     use_point: dataPreview.usePoint,
  //   };
  //   mutateOtpCheckoutVerify(body);
  // };

  const { mutate: mutateOtpCheckout } = useMutation({
    mutationFn: OtpCheckout,
    onSuccess: () => setIsPressed(true),
  });

  const {
    mutate: mutatePaymentDetail,
    data: dataPaymentDetail,
    isLoadingPaymentDetail,
  } = useMutation({
    mutationFn: fetchPaymentDetailPbf,
    onSuccess: (data) => {
      if (data.expired_at) {
        const target = new Date(data.expired_at).getTime();
        const now = Date.now();

        const diffInSeconds = Math.floor((target - now) / 1000);
        setTime(diffInSeconds);
      }
      setCollapsePaymentArr([...Array(data?.instructions?.length).fill(false)]);
      if (invoiceNum && data.action_url && data.action_url !== "")
        window.open(data.action_url);
    },
  });

  // const {
  //   mutate: mutateOtpCheckoutVerify,
  //   isLoading: isLoadingOtpCheckoutVerify,
  // } = useMutation({
  //   mutationFn: verifyCheckoutOtpNew,
  //   onSuccess: (data) => {
  //     if (dataPreview && dataPreview?.payment.id === 22 && data)
  //       navigate(`/purchase-pbf`);
  //     // if (dataPreview && dataPreview?.payment.id === 21 && data)
  //     //   window.open(data.redirect?.redirect, "_blank");
  //     if (
  //       dataPreview &&
  //       (dataPreview?.payment.id === 19 ||
  //         dataPreview?.payment_id === 21 ||
  //         dataPreview?.payment.id === 24) &&
  //       data
  //     ) {
  //       navigate(`/purchase-pbf/list-transaction/1`);
  //       window.open(data.redirect.redirect, "_blank");
  //     }
  //     if (dataPreview && dataPreview?.payment.id === 23 && data)
  //       navigate(`/online-billing`);
  //     if (
  //       dataPreview &&
  //       dataPreview?.payment.id !== 19 &&
  //       dataPreview?.payment.id !== 24 &&
  //       dataPreview?.payment.id !== 22 &&
  //       dataPreview?.payment.id !== 21 &&
  //       data &&
  //       data.verify
  //     )
  //       navigate(`/purchase-pbf/confirm-checkout/${data.verify.invoice}`);
  //   },
  //   onError: (err) => {
  //     setErrorVerify(true);
  //     setErrorMessage(err.message.id ? err.message.id : err.message);
  //   },
  // });

  const { mutate: mutatePaymentCheck, isLoading: isLoadingPaymentCheck } =
    useMutation({
      mutationFn: paymentCheckPbf,
      onSuccess: (data) => {
        if (data && data.payment_status === 2) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          navigate(`/purchase-pbf/checkout-result/${invoiceNum}`);
        } else {
          setErrorMessage("Pembayaran belum berhasil");
        }
      },
      onError: (err) => {
        setErrorMessage(err.message.id ? err.message.id : err.message);
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      },
    });

  useEffect(() => {
    if (!invoiceNum) return;

    intervalRef.current = setInterval(() => {
      mutatePaymentCheck({ invoice_uid: invoiceNum });
    }, 60000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [invoiceNum, mutatePaymentCheck]);

  useEffect(() => {
    if (invoiceNum) mutatePaymentDetail({ invoice_uid: invoiceNum });
  }, [invoiceNum]);

  // useEffect(() => {
  //   if (!isPressed) {
  //     setCountdownSeconds(COUNTDOWN_SECOND);
  //     return;
  //   }

  //   const interval = setInterval(() => {
  //     setCountdownSeconds((prevCount) => {
  //       if (prevCount === 0) {
  //         clearInterval(interval);
  //         setIsPressed(false);
  //         setCountdownSeconds(COUNTDOWN_SECOND);
  //         return prevCount;
  //       }
  //       return prevCount - 1;
  //     });

  //     return () => clearInterval(interval);
  //   }, 1000);
  // }, [isPressed]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (time > 0) {
        setTime((prevValue) => prevValue - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [time]);

  const hours = Math.floor(Math.floor(time / 3600) / 1000);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  const formattedTime = `${("0" + hours).slice(-2)} : ${("0" + minutes).slice(
    -2,
  )} : ${("0" + seconds).slice(-2)}`;

  // useEffect(() => {
  //   // Send OTP if not CC or pay later
  //   if (
  //     dataPreview &&
  //     dataPreview?.payment.id !== 19 &&
  //     dataPreview?.payment.id !== 24 &&
  //     dataPreview?.payment.id !== 21 &&
  //     dataPreview?.payment.id !== 22 &&
  //     dataPreview?.payment.id !== 23
  //   )
  //     mutateOtpCheckout();
  //   // credit card, pay later (excl. amanah) doesn't need otp or pin
  //   if (
  //     dataPreview &&
  //     (dataPreview?.payment.id === 19 ||
  //       dataPreview?.payment.id === 24 ||
  //       dataPreview?.payment.id === 21 ||
  //       dataPreview?.payment.id === 23)
  //   ) {
  //     handleVerifyOtp(null);
  //   }
  // }, []);

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <LoadingBackdrop
        isLoading={
          // isLoadingOtpCheckoutVerify ||
          invoiceNum && isLoadingPaymentDetail //||
          // (dataPreview && dataPreview.payment?.id === 19)
        }
      />
      <PurchaseHeader />

      <div className="mt-[70px]">
        <div className="px-3 pt-2 mb-4">
          <BreadcrumbPurchase isConfirmCheckout={true} />
        </div>
        <div className="px-3 mb-4">
          <p className="text-[24px] font-semibold">Konfirmasi Pembayaran</p>
        </div>

        {invoiceNum && dataPaymentDetail && !isLoadingPaymentDetail ? (
          // can be va or redirect
          <div className="px-3 mb-4">
            {dataPaymentDetail.action_url ? (
              <div>
                <div className="p-4 bg-white rounded-lg mb-4">
                  <div className="flex items-center justify-between mb-4">
                    <p className="text-[16px] font-semibold">Bayar Melalui</p>
                    <div className="flex items-center gap-2">
                      <p className="text-[14px]">
                        {dataPaymentDetail.payment_method_name}
                      </p>
                      <img
                        src={dataPaymentDetail.payment_method_logo}
                        className="w-[80px] h-[30px] object-contain"
                      />
                    </div>
                  </div>

                  <div className="flex items-center justify-between gap-4">
                    <p>
                      Jika halaman tidak teralihkan secara otomatis, silakan
                      klik tombol berikut.
                    </p>

                    <button
                      onClick={() => {
                        window.open(dataPaymentDetail.action_url);
                        window.location.reload();
                      }}
                      className="px-4 py-2 rounded-full bg-blue-500 text-white font-bold"
                    >
                      Bayar
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="bg-red-100 flex justify-between items-center text-[16px] mb-4 rounded-md px-3 py-2">
                  <p className="font-semibold">Bayar Sebelum</p>
                  <p className="text-red-500 font-bold">{formattedTime}</p>
                </div>

                <div className="p-4 bg-white rounded-lg mb-4">
                  <div className="flex items-center justify-between mb-4">
                    <p className="text-[16px] font-semibold">Bayar Melalui</p>
                    <div className="flex items-center gap-2">
                      <p className="text-[14px]">
                        {dataPaymentDetail.payment_method_name}
                      </p>
                      <img
                        src={dataPaymentDetail.payment_method_logo}
                        className="w-[80px] h-[30px] object-contain"
                      />
                    </div>
                  </div>

                  <div className="block md:flex items-center gap-2 mb-2">
                    {dataPaymentDetail.account_no?.slice(0, 5) !== "https" ? (
                      <div className="w-full text-center mb-2 md:mb-0">
                        <p>Nomor Virtual Account</p>
                        <div className="bg-[#E6E8F3] p-2.5 rounded-md font-bold text-[16px] flex items-center gap-4 justify-center">
                          <p id="vaNum">{dataPaymentDetail.account_no}</p>
                          <FaRegCopy
                            className="cursor-pointer hover:text-gray-500"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                document.getElementById("vaNum").innerHTML,
                              );
                              setIsCopied(true);
                            }}
                          />
                        </div>
                      </div>
                    ) : null}
                    <div className="w-full text-center">
                      <p>Total Pembayaran</p>
                      <div className="bg-[#F7F8F9] p-2.5 rounded-md font-bold text-[16px]">
                        {toIDR(
                          dataPaymentDetail.verify
                            ? dataPaymentDetail.verify.total
                            : dataPaymentDetail.total_payment,
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 text-red-500 mb-2">
                    <IoIosInformationCircleOutline className="text-[20px]" />
                    <p>
                      Pastikan nomor virtual account/pelanggan yang kamu masukan
                      benar. OLIN Tidak Bertanggung Jawab jika Terjadi kesalahan
                      pengisian data.
                    </p>
                  </div>

                  <div className="p-4 bg-white rounded-lg mb-4">
                    <p className="text-[16px] font-semibold">
                      Instruksi Pembayaran
                    </p>
                    {dataPaymentDetail.instructions?.map((item, i) => {
                      return (
                        <div className={`${i === 0 ? "mt-4" : ""}`}>
                          {i === 0 ? null : <hr className="my-3" />}
                          <div
                            className="flex justify-between items-center font-bold hover:text-gray-300 cursor-pointer"
                            onClick={() =>
                              setCollapsePaymentArr([
                                ...collapsePaymentArr.slice(0, i),
                                !collapsePaymentArr[i],
                                ...collapsePaymentArr.slice(i + 1),
                              ])
                            }
                          >
                            <p>{item.source}</p>
                            {collapsePaymentArr[i] ? (
                              <FaChevronUp />
                            ) : (
                              <FaChevronDown />
                            )}
                          </div>
                          <Collapse
                            in={collapsePaymentArr[i]}
                            timeout="auto"
                            unmountOnExit
                          >
                            {item.instruction.map((point) => (
                              <p>{point}</p>
                            ))}
                          </Collapse>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
            <button
              type="button"
              className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-full p-2 text-[14px] disabled:bg-gray-300 lg:mb-2"
              onClick={() => mutatePaymentCheck({ invoice_uid: invoiceNum })}
              disabled={isLoadingPaymentCheck}
            >
              {isLoadingPaymentCheck ? (
                <CircularProgress size={10} />
              ) : (
                "Cek Status Pembayaran"
              )}
            </button>
          </div>
        ) : (
          <div className="px-3 mb-4">
            <CircularProgress size={20} />
          </div>
        )}

        {/* {invoiceNum &&
        dataPaymentDetail &&
        // dataPaymentDetail.verify? &&
        !isLoadingPaymentDetail ? (
          <div className="px-3 mb-4">
            <div className="bg-red-100 flex justify-between items-center text-[16px] mb-4 rounded-md px-3 py-2">
              <p className="font-semibold">Bayar Sebelum</p>
              <p className="text-red-500 font-bold">{formattedTime}</p>
            </div>
            <div className="p-4 bg-white rounded-lg mb-4">
              <div className="flex items-center justify-between mb-4">
                <p className="text-[16px] font-semibold">Bayar Melalui</p>
                <div className="flex items-center gap-2">
                  <p className="text-[14px]">
                    {dataPaymentDetail.payment_type}
                  </p>
                  <img
                    src={dataPaymentDetail.logo}
                    className="w-[80px] h-[30px] object-contain"
                  />
                </div>
              </div>
              <div className="block md:flex items-center gap-2 mb-2">
                {dataPaymentDetail.account_no?.slice(0, 5) !== "https" ? (
                  <div className="w-full text-center mb-2 md:mb-0">
                    <p>Nomor Virtual Account</p>
                    <div className="bg-[#E6E8F3] p-2.5 rounded-md font-bold text-[16px] flex items-center gap-4 justify-center">
                      <p id="vaNum">{dataPaymentDetail.account_no}</p>
                      <FaRegCopy
                        className="cursor-pointer hover:text-gray-500"
                        onClick={() => {
                          navigator.clipboard.writeText(
                            document.getElementById("vaNum").innerHTML,
                          );
                          setIsCopied(true);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
                <div className="w-full text-center">
                  <p>Total Pembayaran</p>
                  <div className="bg-[#F7F8F9] p-2.5 rounded-md font-bold text-[16px]">
                    {toIDR(dataPaymentDetail.verify?.total)}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-red-500 mb-2">
                <IoIosInformationCircleOutline className="text-[20px]" />
                <p>
                  Pastikan nomor virtual account/pelanggan yang kamu masukan
                  benar. OLIN Tidak Bertanggung Jawab jika Terjadi kesalahan
                  pengisian data.
                </p>
              </div>
              <button
                type="button"
                className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-full p-2 text-[14px] disabled:bg-gray-300 lg:mb-2"
                onClick={() => mutatePaymentCheck({ invoice: invoiceNum })}
                disabled={isLoadingPaymentCheck}
              >
                {isLoadingPaymentCheck ? (
                  <CircularProgress size={10} />
                ) : (
                  "Cek Status Pembayaran"
                )}
              </button>
            </div>
            <div className="p-4 bg-white rounded-lg mb-4">
              <p className="text-[16px] font-semibold">Instruksi Pembayaran</p>
              {dataPaymentDetail.verify?.data?.map((item, i) => {
                return (
                  <div className={`${i === 0 ? "mt-4" : ""}`}>
                    {i === 0 ? null : <hr className="my-3" />}
                    <div
                      className="flex justify-between items-center font-bold hover:text-gray-300 cursor-pointer"
                      onClick={() =>
                        setCollapsePaymentArr([
                          ...collapsePaymentArr.slice(0, i),
                          !collapsePaymentArr[i],
                          ...collapsePaymentArr.slice(i + 1),
                        ])
                      }
                    >
                      <p>{item.source}</p>
                      {collapsePaymentArr[i] ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </div>
                    <Collapse
                      in={collapsePaymentArr[i]}
                      timeout="auto"
                      unmountOnExit
                    >
                      {item.instruction.map((point) => (
                        <p>{point}</p>
                      ))}
                    </Collapse>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="px-3 mb-4">
            <CircularProgress size={20} />
          </div>
        )} */}
      </div>

      <Snackbar
        open={isCopied}
        onClose={() => setIsCopied(false)}
        message={"Virtual Account Number Copied"}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      />

      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default CheckoutConfirm;
